import React from 'react'

import { ButtonAndFormModal } from '@/components/layout/modals/ButtonAndFormModal'
import { AdminNotificationSetupForm } from '@/views/Organizations/components/AdminNotificationSetupForm'

// Admin entry point on Organization Management → Notification setup.
// Opens the picker + matrix flow that lets an org admin configure
// notifications on behalf of N users at once.
export const ManageNotificationSetupButton = ({ organizationId }) => (
  <ButtonAndFormModal
    buttonLabel="Manage Notification Setup"
    modalTitle="Notification Setup"
    modalId="manage-notification-setup"
    modalProps={{ size: 'small' }}
    buttonProps={{ primary: true }}
    form={<AdminNotificationSetupForm organizationId={organizationId} />}
  />
)
